// src/services/stripeService.ts
import { generateClient } from 'aws-amplify/api';
import { getStripeConfig } from '../graphql/queries';

const client = generateClient();

interface StripeConfig {
  publishableKey: string;
  allowedCards: string[];
  billingEnabled: boolean;
}

/**
 * Fetches Stripe configuration including the publishable key
 */
export const fetchStripeConfig = async (): Promise<StripeConfig> => {
  try {
    const response: any = await client.graphql({
      query: getStripeConfig,
      authMode: "userPool"
    });
    
    return response.data.getStripeConfig;
  } catch (error) {
    console.error('Error fetching Stripe configuration:', error);
    throw error;
  }
};